
import React, {useEffect, useState} from 'react';
import './TreeView.css'

import { useStateValue } from '../utils/Provider/StateProvider';



import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
} from 'react-flow-renderer';

import { useHistory } from 'react-router-dom';




const onInit = (reactFlowInstance) => console.log('flow loaded:', reactFlowInstance);

function FamilyTreeView() {
    // My States 
    const [{ myrelative, linkedFamily }, dispatch] = useStateValue();
    const history = useHistory();
    
    
    const [handleNode, setHandleNode] = useState([
        {
            id: 'myfamily',
            type:'myfamily',
            data: {
                label: (
                <div className='parent treeview_node' >{/* onDoubleClick={() => {displayFamilyTreeModal(true);setFamilyCLickedName('MyFamily')}} */}
                    My Family
                </div>
                ),
            },
            style:{
                backgroundColor: "crimson",
                padding: '10px',
                border: '1px solid red',
                borderRadius: '5px',
            },
            position: { x: 30, y: 0 },
        }
    ])
    const [handleEdge, setHandleEdge] = useState([])


    
    // When page is loaded Display this error:
    window.onload = function () {
        
        dispatch({
            type: 'NOTIFY_ERROR',
            error: "Oopps! Un-necessary action triggered"
        })
        history.push('/')
    }

    // Random position generator:
    const randomX = () => {
        return Math.floor(Math.random() * (700 - 50 + 1)) + 50;
    }

    const randomY = () => {
        return Math.floor(Math.random() * (1000 - 20 + 1)) + 20;
    }


    useEffect(() => {
        // Parent Node

        
        if(myrelative){
            console.log(myrelative)
            Object.keys(myrelative).map(i => {
                    const node = {
                        id: myrelative[i].uuid,
                        type: myrelative[i].person_data[0].known_as,
                        data: {
                            label: (
                            <div className='parent treeview_node'>{/*  onClick={() => {displayFamilyTreeModal(true);setFamilyCLickedName('MyFamily')}} */}
                                <p className='treeview_node_title'>{myrelative[i].person_data[0].family_name}</p>
                                {/* <p className='treeview_node_id'>{myrelative[i].uuid}</p> */}
                                
                                <div className='treeview_person_names_div'>
                                    {myrelative[i].person_data.map(j => (
                                        <p><i class='fa fa-user'></i>{j.name.includes(" ") ? j.name.split(" ")[0] : j.name}</p>
                                    ))}
                                </div> 
                            </div>
                            ),
                        },
                        style:{
                            backgroundColor: myrelative[i].person_data[0].known_as ? mapColors[myrelative[i].person_data[0].known_as] : "rgb(242, 242, 242)",
                            padding: '10px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        },
                        position: { x: randomX(), y: randomY() },
                    }
                    console.log(node)
    
                    handleNode.push(node)
                    
                })

                Object.keys(myrelative).map(i => {
                    const edg = {
                        id:  `e-${myrelative[i].uuid}`,
                        source:  "myfamily",
                        target:  myrelative[i].uuid,
                        // animated: true,
                        // type: 'smoothstep',
                        labelStyle: { fill: '#f6ab6c', fontWeight: 500 },
                        style: { stroke: mapColors[myrelative[i].person_data[0].known_as], border: '1px solid black' },
                        label: myrelative[i].person_data[0].known_as=== 'custom' ? myrelative[i].person_data[0].known_by.split(" ")[0] + "'s" + myrelative[i].person_data[0].custom_knownas : myrelative[i].person_data[0].known_by.split(" ")[0] + "'s "+ myrelative[i].person_data[0].known_as,
                    }
    
                    handleEdge.push(edg)
                    
                })
                


                if(linkedFamily){
                    Object.keys(linkedFamily).map(i => {
                        const edg = {
                            id:  `e-${linkedFamily[i].uuid}`,
                            source: linkedFamily[i].from,
                            target:  linkedFamily[i].to,
                            animated: true,
                            labelStyle: { fill: 'green', fontSize: '10px' },
                            style: { stroke: mapColors[linkedFamily[i].relatedAs], border: '1px solid black' },
                            label:  getSplit(linkedFamily[i].relativeIs) + " and " + getSplit(linkedFamily[i].relativeOf) + " are " + linkedFamily[i].relatedAs   ,
                        }
        
                        handleEdge.push(edg)
                        
                    })
                }

                
        
        }
        

    }, [myrelative, linkedFamily])
    
    const getSplit = (e) => {
        if(/\s/.test(e)){
            return e.split(" ")[0]
        } else {
            return e
        }

    }
    const mapColors = {
        'myfamily':'white',
        'friend': 'yellow',
        'brother': 'blue',
        'sister': 'skyblue',
        'kaka': 'green',
        'kaku': 'lightgreen',
        'mama': 'orange',
        'mami': 'brown',
        'maushi': 'maroon',
        'aatya': 'magenta',
        'custom': 'grey'
    }

   
    
    // Original Main States:
    const [nodes, setNodes, onNodesChange] = useNodesState(handleNode);
    const [edges, setEdges, onEdgesChange] = useEdgesState(handleEdge);
    const onConnect = (params) => setEdges((eds) => addEdge(params, eds));


  return (
    <div className='family_treeView_container'  style={{width: '100%', height:'80vh', backgroundColor:"#fff"}}>
        {/* <button onClick={() => {console.log(myrelative)}}>Check</button> */}

        {myrelative && 
            <ReactFlow
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                onInit={onInit}
                fitView
            // attributionPosition="top-right"
            >
            
                <MiniMap
                    nodeStrokeColor={(n) => {
                    if (n.style?.background) return n.style.background;
                    if (n.type === 'myfamily') return 'red';
                    if (n.type === 'output') return '#ff0072';
                    if (n.type === 'brother') return  'blue';
                    if (n.type === 'sister' ) return 'skyblue';
                    if (n.type === 'kaka') return  'green';
                    if (n.type === 'kaku') return  'lightgreen';
                    if (n.type === 'mama') return  'orange';
                    if (n.type === 'mami') return  'brown';
                    if (n.type === 'maushi') return  'maroon';
                    if (n.type === 'aatya') return  'magenta';
                    if (n.type === 'custom') return  'grey';
                    if (n.type === '') return  '#ccc';


                    return '#eee';
                    }}
                    nodeColor={(n) => {
                    if (n.style?.background) return n.style.background;

                    return '#fff';
                    }}
                    nodeBorderRadius={2}
                />
                <Controls />
                <Background color="#aaa" gap={16} />
            </ReactFlow>
        }

        {!myrelative && <p>get relatives</p>}

    </div>
  )
}

export default FamilyTreeView